import FunnelGraph from "../../../../../components/funnelGraph/funnelGraph";
import {connect} from "react-redux";
// import { actionCreators } from "../redux/sagas/funnelChart/funnelChart"

export default connect(
  state => ({
    id: "introOfferFunnelChart",
    colors: [
      ["#0099ce", "#005a79"],
      ["#42b77a", "#20583b"],
      ["#ff664e", "#6d2e24"],
      ["#5873fd", "#28326b"]
    ],
    direction: "horizontal",
    gradientDirection: "vertical",
    labels: state.funnelChart.funnelIntroOffers.chart.data.labels, //["Lead", "Appointment", "Show", "Enrollment"],
    subLabels: state.funnelChart.funnelIntroOffers.chart.data.subLabels,
    hideSubLabels: true,
    subLabelVisibility: [false, true, true, true],
    width: 1350,
    height: 450,
    values: state.funnelChart.funnelIntroOffers.chart.data.values,
    rawDataValues: state.funnelChart.funnelIntroOffers.chart.data.rawDataValues,
    subPercents: state.funnelChart.funnelIntroOffers.chart.data.subPercents,
    breakdownRawData: state.funnelChart.funnelIntroOffers.chart.data.breakdownRawData,
    percentLabels: state.funnelChart.funnelIntroOffers.chart.data.percentLabels //[["Lead to Appointment"], ["Lead to Show", "Appointment to Show"], ["Lead to Enrollment", "Show to Enrollment"]]
  }),
  {}
)(FunnelGraph);
